enum DrawerDirections {
  RIGHT = 'right',
  BOTTOM = 'bottom',
  FULLHEIGHT = 'full-height',
}
enum DrawerOpenAt {
  DEFAULT = 'default',
  HALF_SCREEN = 'half-screen',
}
export { DrawerDirections, DrawerOpenAt };
